export default __webpack_public_path__ + "static/media/norewards_img.a58cee0c.png";